import { render, staticRenderFns } from "./OpenAppFooter.vue?vue&type=template&id=8f61bc7a&scoped=true"
import script from "./OpenAppFooter.vue?vue&type=script&lang=js"
export * from "./OpenAppFooter.vue?vue&type=script&lang=js"
import style0 from "./OpenAppFooter.vue?vue&type=style&index=0&id=8f61bc7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@6.26.3_cache-loader@4.1.0_webpac_ddacfd63a0804571a953918ce6bcb0d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f61bc7a",
  null
  
)

export default component.exports